import { KnobDesignTokens } from '@primeuix/themes/types/knob';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tFlat } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/knob/index.ts
const knob = componentCommon.knob;

export const KnobTelekomDT: KnobDesignTokens = {
  root: {
    focusRing: tFlat(knob.focus.ring),
  },
  value: {
    background: t(knob.value.background),
  },
  range: {
    background: t(knob.range.background),
  },
  text: {
    color: t(knob.text.color),
  },
};
